import { Injectable, defineInjectable, inject, Component, Input, Output, EventEmitter, NgModule } from '@angular/core';
import { of, Subscription, timer, Subject } from 'rxjs';
import { __extends, __values } from 'tslib';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { tap, catchError, takeUntil, switchMap } from 'rxjs/operators';
import { AuthService, AuthModule } from 'auth';
import { LoggerService, AngularMaterialModule, UtilsModule, ConsoleLoggerService } from 'utils';
import { DynamicFormService, DynamicFormsModule } from 'dynamic-forms';
import { format } from 'date-fns';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
CollectionService = /** @class */ (function () {
    function CollectionService(authService, httpClient, logger) {
        this.authService = authService;
        this.httpClient = httpClient;
        this.logger = logger;
        // private processEngineUriPrefix = 'http://localhost:8080/flowable-task/process-api/runtime/';
        this.processEngineUriPrefix = '/flowable-task/process-api/';
        this.httpOptions = null;
    }
    /**
     * @protected
     * @param {?} params
     * @return {?}
     */
    CollectionService.prototype.getHttpOptions = /**
     * @protected
     * @param {?} params
     * @return {?}
     */
    function (params) {
        this.logger.info('CollectionService: getHttpOptions()');
        if (!this.httpOptions) {
            /** @type {?} */
            var user = this.authService.getUser();
            if (typeof user === 'undefined') {
                this.logger.error('CollectionService getHttpOptions() - user is undefined');
                return this.httpOptions;
            }
            /** @type {?} */
            var token = user.username + ':' + user.password;
            this.logger.info('CollectionService getHttpOptions() - token: ' + token);
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(token)
                }),
                params: null
            };
        }
        this.httpOptions.params = params;
        // this.logger.info(JSON.stringify(this.httpOptions));
        return this.httpOptions;
    };
    /**
     * @protected
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    CollectionService.prototype.handleError = /**
     * @protected
     * @template T
     * @param {?=} operation
     * @param {?=} result
     * @return {?}
     */
    function (operation, result) {
        var _this = this;
        return (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            // TODO: send the error to your remote logging infrastructure e.g., Sentry
            _this.logger.error(error);
            // TODO: better job of transforming error for user consumption
            // this.logger.info(operation + ' failed: ' + error.message);
            // Let the app keep running by returning an empty result
            return of((/** @type {?} */ (result)));
        });
    };
    return CollectionService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var completeTaskBody = {
    'action': 'complete',
    'variables': []
};
var TasksService = /** @class */ (function (_super) {
    __extends(TasksService, _super);
    function TasksService(authService, httpClient, logger) {
        var _this = _super.call(this, authService, httpClient, logger) || this;
        _this.authService = authService;
        _this.httpClient = httpClient;
        _this.logger = logger;
        return _this;
    }
    // public getTasks(): Observable<TaskListModel>   {
    // public getTasks(): Observable<TaskListModel>   {
    /**
     * @return {?}
     */
    TasksService.prototype.getTasks = 
    // public getTasks(): Observable<TaskListModel>   {
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('TasksService: getTasks()');
        /** @type {?} */
        var endpoint = this.processEngineUriPrefix + "runtime/tasks";
        // https://www.flowable.org/docs/userguide/index.html#_request_parameters
        /** @type {?} */
        var sort = 'createTime';
        /** @type {?} */
        var order = 'desc';
        // const start = 0;
        // const size = 16;
        /** @type {?} */
        var params = new HttpParams().set('sort', sort).set('order', order);
        return this.httpClient.get(endpoint, this.getHttpOptions(params))
            .pipe(tap((/**
         * @return {?}
         */
        function () {
            _this.logger.info('TasksService: getTasks() completed');
        })), catchError(this.handleError('getTasks', [])));
    };
    /**
     * @param {?} taskId
     * @return {?}
     */
    TasksService.prototype.completeTask = /**
     * @param {?} taskId
     * @return {?}
     */
    function (taskId) {
        var _this = this;
        this.logger.info('TasksService: completeTask()');
        /** @type {?} */
        var endpoint = this.processEngineUriPrefix + "runtime/tasks/" + taskId;
        this.logger.info('TasksService completeTask() - endpoint: ' + endpoint);
        return this.httpClient.post(endpoint, completeTaskBody, this.getHttpOptions(null))
            .pipe(tap((/**
         * @return {?}
         */
        function () {
            _this.logger.info('TasksService: completeTask() completed');
        })), catchError(this.handleError('completeTask', [])));
    };
    TasksService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    TasksService.ctorParameters = function () { return [
        { type: AuthService },
        { type: HttpClient },
        { type: LoggerService }
    ]; };
    /** @nocollapse */ TasksService.ngInjectableDef = defineInjectable({ factory: function TasksService_Factory() { return new TasksService(inject(AuthService), inject(HttpClient), inject(LoggerService)); }, token: TasksService, providedIn: "root" });
    return TasksService;
}(CollectionService));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FormsService = /** @class */ (function (_super) {
    __extends(FormsService, _super);
    function FormsService(authService, httpClient, logger) {
        var _this = _super.call(this, authService, httpClient, logger) || this;
        _this.authService = authService;
        _this.httpClient = httpClient;
        _this.logger = logger;
        return _this;
    }
    /**
     * @param {?} body
     * @return {?}
     */
    FormsService.prototype.submitFormData = /**
     * @param {?} body
     * @return {?}
     */
    function (body) {
        var _this = this;
        this.logger.info('FormsService: submitFormData()');
        /** @type {?} */
        var endpoint = this.processEngineUriPrefix + "form/form-data";
        this.httpOptions.params = null;
        this.logger.info('FormsService submitFormData() - endpoint: ' + endpoint);
        return this.httpClient.post(endpoint, body, this.getHttpOptions(null))
            .pipe(tap((/**
         * @return {?}
         */
        function () {
            _this.logger.info('FormsService: submitFormData() completed');
        })), catchError(this.handleError('submitFormData', [])));
    };
    FormsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    FormsService.ctorParameters = function () { return [
        { type: AuthService },
        { type: HttpClient },
        { type: LoggerService }
    ]; };
    /** @nocollapse */ FormsService.ngInjectableDef = defineInjectable({ factory: function FormsService_Factory() { return new FormsService(inject(AuthService), inject(HttpClient), inject(LoggerService)); }, token: FormsService, providedIn: "root" });
    return FormsService;
}(CollectionService));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TaskComponent = /** @class */ (function () {
    function TaskComponent(dynamicFormService, tasksService, formsService, logger) {
        this.dynamicFormService = dynamicFormService;
        this.tasksService = tasksService;
        this.formsService = formsService;
        this.logger = logger;
        this.completeEvent = new EventEmitter();
        this.completeButton = 'COMPLETE';
        this.subscriptions = [];
    }
    /**
     * @return {?}
     */
    TaskComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.logger.info('TaskComponent: ngOnInit()');
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    TaskComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        this.logger.info('TaskComponent: ngOnChanges()');
        this.unsubscribe();
        // TODO
        this.taskModel = null;
        this.taskFormGroup = null;
        if (this.task && this.task.formKey) {
            this.subscribe();
        }
    };
    /**
     * @protected
     * @return {?}
     */
    TaskComponent.prototype.subscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('TaskComponent: subscribe()');
        this.logger.info('TaskComponent - formId: ' + this.task.formKey);
        /** @type {?} */
        var formSubscription = new Subscription();
        this.subscriptions.push(formSubscription);
        formSubscription = this.dynamicFormService.getFormMetadata(this.task.formKey).subscribe((/**
         * @param {?} metaData
         * @return {?}
         */
        function (metaData) {
            _this.taskModel = metaData;
            _this.taskFormGroup = _this.dynamicFormService.createGroup(_this.taskModel);
        }));
    };
    /**
     * @protected
     * @return {?}
     */
    TaskComponent.prototype.unsubscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        this.logger.info('TaskComponent: unsubscribe()');
        this.subscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        function (subscription) {
            subscription.unsubscribe();
        }));
    };
    /**
     * @return {?}
     */
    TaskComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.logger.info('TaskComponent: ngOnDestroy()');
        this.unsubscribe();
    };
    //
    // Misc
    //
    //
    // Misc
    //
    /**
     * @return {?}
     */
    TaskComponent.prototype.isValid = 
    //
    // Misc
    //
    /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var valid = true;
        if (this.taskFormGroup) {
            valid = this.taskFormGroup.valid;
        }
        return valid;
    };
    //
    // Command events
    //
    //
    // Command events
    //
    /**
     * @return {?}
     */
    TaskComponent.prototype.onComplete = 
    //
    // Command events
    //
    /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('TaskComponent: onComplete()');
        /** @type {?} */
        var subscription;
        if (this.taskFormGroup) {
            /** @type {?} */
            var properties_1 = [];
            /** @type {?} */
            var type_1 = 'string';
            /** @type {?} */
            var value_1 = '';
            this.taskModel.forEach((/**
             * @param {?} controlModel
             * @return {?}
             */
            function (controlModel) {
                // 'string | date'
                type_1 = controlModel.type === 'input' ? 'string' : controlModel.type;
                value_1 = _this.taskFormGroup.value[controlModel.id.valueOf()];
                // TODO handle locales, etc.
                if (type_1 === 'date') {
                    value_1 = format(value_1, 'DD-MM-YYYY');
                }
                properties_1.push({
                    'id': controlModel.id,
                    'name': controlModel.name,
                    'type': type_1,
                    'value': value_1
                });
            }));
            /** @type {?} */
            var body = { 'taskId': this.task.id, 'properties': properties_1 };
            this.logger.info('body: ' + JSON.stringify(body));
            subscription = this.formsService.submitFormData(body).subscribe((/**
             * @return {?}
             */
            function () {
                _this.completeEvent.emit({ id: _this.task.id });
                subscription.unsubscribe();
            }));
        }
        else {
            subscription = this.tasksService.completeTask(this.task.id).subscribe((/**
             * @return {?}
             */
            function () {
                _this.completeEvent.emit({ id: _this.task.id });
                subscription.unsubscribe();
            }));
        }
    };
    TaskComponent.decorators = [
        { type: Component, args: [{
                    selector: 'flow-task',
                    template: "<!-- Task Header -->\n\n<div *ngIf=\"task\" class=\"task-header\">\n\n  <div class=\"task-header-content\">\n\n    <h2> {{ task.name }} </h2>\n    <button mat-raised-button color=\"accent\" [disabled]=\"!isValid()\" (click)=\"onComplete()\"> {{ completeButton }} </button>\n\n  </div>\n\n</div>\n\n<!-- Task Content -->\n\n<div *ngIf=\"taskFormGroup\" class=\"task-content\">\n\n  <dynamic-form autocomplete=\"off\"\n                [className]=\"'crm-nested-grid-container'\"\n                [formGroup]=\"taskFormGroup\"\n                [model]=\"taskModel\">\n  </dynamic-form>\n\n</div>\n",
                    styles: [".task-header{background:#f5f5f5;height:80px;min-height:80px}.task-header-content{display:flex;flex-direction:row;align-items:center;justify-content:space-between;background:#f5f5f5;padding-left:16px;padding-right:16px}.task-content{background:#fff;padding:16px}"]
                }] }
    ];
    /** @nocollapse */
    TaskComponent.ctorParameters = function () { return [
        { type: DynamicFormService },
        { type: TasksService },
        { type: FormsService },
        { type: LoggerService }
    ]; };
    TaskComponent.propDecorators = {
        task: [{ type: Input }],
        completeEvent: [{ type: Output }]
    };
    return TaskComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// const INTERVAL = 5000;
var TaskListComponent = /** @class */ (function () {
    function TaskListComponent(tasksService, logger) {
        this.tasksService = tasksService;
        this.logger = logger;
        this.selectedItem = null;
        this.subscriptions = [];
        this.componentDestroyed = new Subject();
    }
    /**
     * @return {?}
     */
    TaskListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.logger.info('TaskListComponent: ngOnInit()');
        this.subscribe();
        // this.pollingSubscribe();
    };
    /**
     * @return {?}
     */
    TaskListComponent.prototype.refresh = /**
     * @return {?}
     */
    function () {
        this.logger.info('TaskListComponent: refresh()');
        this.unsubscribe();
        this.subscribe();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    TaskListComponent.prototype.onCompleteEvent = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.logger.info('TaskListComponent: onCompleteEvent()');
        this.logger.info('TaskListComponent - taskId: ' + event.id);
        this.selectedItem = null;
        this.refresh();
    };
    /**
     * @protected
     * @return {?}
     */
    TaskListComponent.prototype.subscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('TaskListComponent: subscribe()');
        /** @type {?} */
        var modelSubscription = new Subscription();
        this.subscriptions.push(modelSubscription);
        // modelSubscription = this.tasksService.getTasks().subscribe(model => {
        modelSubscription = this.tasksService.getTasks().subscribe((/**
         * @param {?} model
         * @return {?}
         */
        function (model) {
            _this.items = model.data;
            _this.selectedItem = _this.items[0];
        }));
    };
    /**
     * @protected
     * @return {?}
     */
    TaskListComponent.prototype.pollingSubscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.logger.info('TaskListComponent: subscribe()');
        /** @type {?} */
        var modelSubscription = new Subscription();
        this.subscriptions.push(modelSubscription);
        modelSubscription = timer(0, 5000).pipe(takeUntil(this.componentDestroyed), switchMap((/**
         * @return {?}
         */
        function () { return _this.tasksService.getTasks(); }))).subscribe((/**
         * @param {?} model
         * @return {?}
         */
        function (model) {
            var e_1, _a;
            _this.items = model.data;
            if (_this.selectedItem) {
                try {
                    for (var _b = __values(_this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        if (item.id === _this.selectedItem.id) {
                            _this.selectedItem = item;
                            break;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            else {
                _this.selectedItem = _this.items[0];
            }
        }));
    };
    /**
     * @protected
     * @return {?}
     */
    TaskListComponent.prototype.unsubscribe = /**
     * @protected
     * @return {?}
     */
    function () {
        this.logger.info('TaskListComponent: unsubscribe()');
        this.subscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        function (subscription) {
            subscription.unsubscribe();
        }));
    };
    /**
     * @param {?} task
     * @return {?}
     */
    TaskListComponent.prototype.onSelect = /**
     * @param {?} task
     * @return {?}
     */
    function (task) {
        this.logger.info('TaskListComponent: onSelect()');
        this.selectedItem = task;
    };
    /**
     * @return {?}
     */
    TaskListComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.logger.info('TaskListComponent: ngOnDestroy()');
        if (this.componentDestroyed) {
            this.componentDestroyed.next(true);
            this.componentDestroyed.unsubscribe();
        }
        this.unsubscribe();
    };
    TaskListComponent.decorators = [
        { type: Component, args: [{
                    selector: 'flow-task-list',
                    template: "<div class=\"crm-activities-container\">\n\n  <div class=\"crm-task-list-container\">\n\n    <mat-nav-list style=\"padding-top: 0\">\n\n      <a *ngFor=\"let item of items\"\n         mat-list-item\n         [class.list-item-active]=\"item === selectedItem\"\n         (click)=\"onSelect(item)\">\n\n        <mat-icon matListIcon class=\"crm-task-list-icon\"> assignment </mat-icon>\n\n        <p mat-line>\n          {{item.name}}\n        </p>\n\n        <p mat-line>\n          {{item.description}}\n        </p>\n\n      </a>\n\n    </mat-nav-list>\n\n  </div>\n\n  <div class=\"crm-task-container\">\n    <flow-task (completeEvent)=\"onCompleteEvent($event)\" [task]=\"selectedItem\"> </flow-task>\n  </div>\n\n</div>\n\n<!--\n\n(completeEvent)=\"onCompleteEvent()\"\n\n         [class.selected]=\"item === selectedItem\"\n\n      <a *ngFor=\"let item of myWorkRoutes\"\n         mat-list-item\n         (click)=\"sidenav.close()\"\n         routerLinkActive\n         #routerLinkActiveInstance=\"routerLinkActive\"\n         [class.list-item-active]=\"routerLinkActiveInstance.isActive\"\n         [routerLink]=\"[item.route]\">\n        <mat-icon matListIcon class=\"app-nav-list-icon\"> {{ item.icon }} </mat-icon>\n        {{item.title}}\n      </a>\n\n         (click)=\"onSelect(item)\">\n\n      <a mat-list-item routerLink=\"/\" style=\"height: 0;\"></a>\n\n-->\n\n<!--\n\n<mat-nav-list>\n\n  <a mat-list-item routerLink=\"/\" style=\"height: 0;\"></a>\n\n  <a *ngFor=\"let item of items\"\n     mat-list-item>\n\n    <mat-icon matListIcon class=\"crm-task-list-icon\"> assignment </mat-icon>\n\n    <p mat-line>\n      {{item.name}}\n    </p>\n\n    <p mat-line>\n      {{item.description}}\n    </p>\n\n  </a>\n\n</mat-nav-list>\n\n-->\n\n\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    TaskListComponent.ctorParameters = function () { return [
        { type: TasksService },
        { type: LoggerService }
    ]; };
    return TaskListComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var FlowableModule = /** @class */ (function () {
    function FlowableModule(logger) {
        this.logger = logger;
        this.logger.info('Flowable Module initialised');
    }
    FlowableModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        AngularMaterialModule,
                        AuthModule,
                        CommonModule,
                        DynamicFormsModule,
                        FlexLayoutModule,
                        ReactiveFormsModule,
                        TranslateModule.forChild(),
                        UtilsModule
                    ],
                    declarations: [TaskComponent, TaskListComponent],
                    providers: [
                        { provide: LoggerService, useClass: ConsoleLoggerService }
                    ],
                    exports: [TaskComponent, TaskListComponent]
                },] }
    ];
    /** @nocollapse */
    FlowableModule.ctorParameters = function () { return [
        { type: LoggerService }
    ]; };
    return FlowableModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { FlowableModule, TaskComponent, TaskListComponent, TasksService, CollectionService as ɵa, FormsService as ɵb };
//# sourceMappingURL=flowable.js.map
